import type { TFunction } from 'i18next'
import type { EpgDateEx } from '~/entities/epg/dates'

import { produce } from 'immer'
import { DATE_FORMATS, formatStartTime } from '~/shared/helpers/date'

export const translateDate = (t: TFunction) => (date: EpgDateEx) =>
  produce(date, (draft) => {
    const yesterday = t('yesterday')
    const today = t('today')
    const tomorrow = t('tomorrow')
    const title = formatStartTime(
      new Date(draft.year, draft.month, draft.day),
      DATE_FORMATS.DD_MMM
    )
    if (draft.isYesterday) {
      draft.title = yesterday
    } else if (draft.isToday) {
      draft.title = today
    } else if (draft.isTomorrow) {
      draft.title = tomorrow
    } else {
      draft.title = title
    }
  })
